import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { JobComment } from "@/types";

/**
 * This hook is used to remove a job comment in the job comments query
 * without refetching the entire query.
 */
export const useRemoveJobComment = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({ jobCommentId }: { jobCommentId: number }) => {
    queryClient.setQueryData(
      ["job-comments", currentCompanyId, currentJobId],
      (cachedData: JobComment[]) => {
        return cachedData.filter(
          (cachedJobComment: JobComment) =>
            cachedJobComment.id !== jobCommentId,
        );
      },
    );
  };
};
